<template>
  <a-layout>
    <a-layout-content style="background-color:white">
      <a-row class="vd-toolbar">
        <a-col class="vd-toolbar-right vd-bar">
          <a-form layout="inline">
            <a-form-item label="时间区间">
              <a-range-picker :default-value="defaultTime"
                              :disabledDate="disabledDate"
                              v-model="defaultTime"
                              :allow-clear="false"
                              format="YYYY/MM/DD"/>
            </a-form-item>
            <a-form-item>
              <a-button-group>
                <a-button @click="rangeDay(7)"> 7 天</a-button>
                <a-button @click="rangeDay(14)"> 14 天</a-button>
              </a-button-group>
            </a-form-item>
            <a-form-item>
              <a-button type="danger" icon="redo" @click="redoItem"/>
            </a-form-item>
          </a-form>
        </a-col>
      </a-row>

      <a-row :gutter="[16,16]">
        <a-col :span="12">
          <a-card title="增长统计" :bordered="true">
            <dailyIncrease :blog-id="id" :date-range="defaultTime"/>
          </a-card>
        </a-col>
        <a-col :span="12">
          <a-card title="消息统计" :bordered="true">
            <dailyMessage :blog-id="id" :date-range="defaultTime"/>
          </a-card>
        </a-col>
      </a-row>
      <a-row :gutter="[16,16]">
        <a-col :span="12">
          <a-card title="内容分析" :bordered="true">
            <dailyContent :blog-id="id" :date-range="defaultTime"/>
          </a-card>
        </a-col>
        <a-col :span="12">
          <a-card title="推送记录" :bordered="true"></a-card>
        </a-col>
      </a-row>

    </a-layout-content>
  </a-layout>
</template>

<script>
  import moment from 'moment'
  import dailyIncrease from '@/components/blogChart/dailyIncrease'
  import dailyMessage from '@/components/blogChart/dailyMessage'
  import dailyContent from '@/components/blogChart/dailyContent'

  export default {
    name: 'DetailMonth',
    components: { dailyIncrease, dailyMessage, dailyContent },
    data () {
      return {
        id: 0,
        defaultTime: [moment().subtract(7, 'days'), moment().subtract(1, 'days')],
        messageChart: null,
      }
    },
    created () {
      this.id = this.$route.query.id
    },
    methods: {
      redoItem () {
        this.defaultTime = [moment().subtract(7, 'days'), moment().subtract(1, 'days')]
      },
      rangeDay (days) {
        this.defaultTime = [moment().subtract(days, 'days'), moment().subtract(1, 'days')]
      },

      disabledDate (current) {
        return current && current > moment().subtract(1, 'days')
      },
    },
  }
</script>

<style scoped>

</style>